<template>
  <!-- 软件服务 -->
  <div class="software_maintenance-mb">
    <div class="title ml71">
      软件服务
    </div>
    <div class="software_main-mb" v-for="(item,i) in software" :key="i">
      <div class="top_pic mobile-container">
        <img :src="item.leftimg">
      </div>
      <div class="bottom_li">
        <h3>{{item.rightul.title}}</h3>
        <ul class="right_li_ul-mb" :class="item.rightul.mianli[0].info===''?'right_li_uls-mb':''">
          <!-- 两次li，定义ref时需要根据外层循环i区分开，防止后面调动画函数时，不能区分造成效果不能正常展示 -->
          <li v-for="(val,k) in item.rightul.mianli" :key="k">
            <img :src="val.imgpic">
            <h4>{{val.titleLi}}</h4>
            <p>{{val.info}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    software: {
      type: Array,
      default: [],
    },
  },
};
</script>
<style lang="scss" scoped>
.software_maintenance-mb {
  background: #f9f9f9;
  padding-bottom: 165px; //284-119 (119=190-71)
  .padding-bottom-213 {
    padding-bottom: 213px;
  }
  .title {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    padding: 284px 0 174px;
    box-sizing: content-box;
    color: #000000;
  }
  .software_main-mb {
    background: #f9f9f9;
    .top_pic {
      img {
        width: 1778px;
        height: 1276px;
      }
    }
    .bottom_li {
      h3 {
        margin: 176px 0 176px 71px;
        font-size: 128px;
        color: #000000;
      }
      // 默认样式 info有内容
      .right_li_ul-mb {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 119px; // 190-71
        li {
          width: 853px;
          height: 782px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          align-items: center;
          text-align: center;
          margin-left: 71px;
          margin-bottom: 71px;
          img {
            display: block;
            height: 280px; //ui勘察为200px 但是icon本身有留白
            width: auto;
            margin-top: 54px; //ui勘察为94px 但是icon本身有留白
          }
          h4 {
            margin-top: 93px; //ui勘察为133px 但是icon本身有留白
            font-size: 85px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #000000;
          }
          p {
            font-size: 56px;
            font-weight: 500;
            color: #000000;
            line-height: 85px;
            margin-top: 68px;
          }
        }
        /* 第1、3、5个子元素 */
        &:nth-child(2n + 1) {
          margin-left: 0px;
        }
      }
      // info为空的样式
      .right_li_uls-mb {
        li {
          img {
            margin-top: 131px; //ui勘察为171px 但是icon本身有留白
          }
          h4 {
            margin-top: 163px; //ui勘察为203px 但是icon本身有留白
          }
          P {
            margin-top: 0;
          }
        }
      }
    }
  }
  .infrastructure_li {
    width: 1778px;
    height: 1120px;
    background-size: cover !important;
    position: relative;
    margin-bottom: 142px;
  }

  .li_bg1 {
    background: url("../../assets/imgs/dedeauto/key_cabinet.jpg") no-repeat;
  }

  .li_bg2 {
    background: url("../../assets/imgs/dedeauto/Oil_card.jpg") no-repeat;
  }

  .li_bg3 {
    background: url("../../assets/imgs/dedeauto/alcohol_test.jpg") no-repeat;
  }
  .li_info {
    font-size: 100px;
    color: #fff;
    position: absolute;
    bottom: 118px;
  }
  .show_info_main-mb {
    width: 100vw;
    background: #f1f6f9;
    .show_info_top {
      h3 {
        font-size: 100px;
        color: #000000;
        padding: 226px 0 94px;
      }
      .show_info_box {
        p {
          font-size: 71px;
        }
        img {
          width: 533px;
          height: 635px;
          display: block;
          margin: 153px auto 176px;
        }
      }
    }
    .show_info_bottom {
      h3 {
        font-size: 100px;
        color: #000000;
        padding: 0 0 94px;
      }
      .show_info_ul {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 107px; // 178-71
        li {
          width: 544px;
          height: 544px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 71px;
          margin-bottom: 71px;
          img {
            width: 200px;
            height: 200px;
            margin-top: 107px;
          }
          p {
            font-size: 71px;
            color: #000000;
            margin-top: 100px;
            text-align: center;
          }
          /* 第1、3、5个子元素 */
          &:nth-child(3n + 1) {
            margin-left: 0px;
          }
        }
      }
    }
  }
}
</style>